import React from 'react';

const Pay = () => {
    return (
        <div>
            <h1 className="m-5 text-primary">Payment system coming soon.</h1>
        </div>
    );
};

export default Pay;